export default "/assets/images/best-product-award-badge-sm.svg?f2c5c59e7d58e1246db0087b3dd4a46e";